import { actionTypes as dataFetchActionTypes } from '@buffer-mono/async-data-fetch'
import { actionTypes as orgActionTypes } from '~publish/legacy/organizations'
import { actions, actionTypes } from './reducer'
import { closeTagForm, openTagForm } from '~publish/legacy/tag-form-modal/slice'

const PROFILE_DISCONNECTED_MODAL_DISMISSED_KEY =
  'profilesDisconnectedModalDismissed'

// @ts-expect-error TS(7031) FIXME: Binding element 'dispatch' implicitly has an 'any'... Remove this comment to see the full error message
export default ({ dispatch, getState }) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'next' implicitly has an 'any' type.
  (next) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
  (action) => {
    next(action)
    switch (action.type) {
      case 'APP_INIT': {
        let modal = null
        const { queryParams: query } = action
        const modalKey = query.get('mk')
        const modalValue = query.get('mv')
        if (modalKey) {
          modal = { key: modalKey }
          if (modalValue) {
            // @ts-expect-error TS(2339) FIXME: Property 'value' does not exist on type '{ key: an... Remove this comment to see the full error message
            modal.value = modalValue
          }
        }
        // @ts-expect-error TS(2339) FIXME: Property '_showModal' does not exist on type 'Wind... Remove this comment to see the full error message
        window._showModal = modal
        break
      }
      case `profiles_${dataFetchActionTypes.FETCH_SUCCESS}`: {
        if (
          action.result &&
          action.result.some(
            (profile: { isDisconnected: boolean; disabled: boolean }) =>
              profile.isDisconnected && !profile.disabled,
          )
        ) {
          // Check if user has already dismissed the modal in this session
          const isDismissed =
            sessionStorage.getItem(PROFILE_DISCONNECTED_MODAL_DISMISSED_KEY) ===
            'true'

          if (isDismissed) {
            break // Don't show modal if already dismissed in this session
          }

          // Check if user is admin and has disconnected profiles in their organization
          const state = getState()
          // Handle cases where selected org might be null but there's a selected org in the list
          let currentOrganization = state.organizations?.selected
          if (!currentOrganization && state.organizations?.list?.length > 0) {
            // Find the organization marked as selected in the list
            currentOrganization =
              state.organizations.list.find((org: any) => org.selected) ||
              state.organizations.list[0]
          }
          const currentOrganizationId = currentOrganization?.id
          const isAdmin = currentOrganization?.isAdmin

          // Only show modal if user is admin
          if (isAdmin) {
            const disconnectedProfilesInOrg = action.result.filter(
              (profile: {
                isDisconnected: boolean
                disabled: boolean
                organizationId: string
              }) =>
                profile.isDisconnected &&
                !profile.disabled &&
                (currentOrganizationId
                  ? profile.organizationId === currentOrganizationId
                  : true),
            )

            // Only dispatch if there are disconnected profiles for this organization
            if (disconnectedProfilesInOrg.length > 0) {
              dispatch(actions.showProfilesDisconnectedModal())
            }
          }
        } else {
          // No disconnected profiles at all - clear the dismissed status
          sessionStorage.removeItem(PROFILE_DISCONNECTED_MODAL_DISMISSED_KEY)
        }
        break
      }

      case orgActionTypes.ORGANIZATION_SELECTED: {
        // Clear dismissed status when switching organizations
        sessionStorage.removeItem(PROFILE_DISCONNECTED_MODAL_DISMISSED_KEY)

        const {
          shouldShowProTrialExpiredModal,
          shouldShowBusinessTrialExpiredModal,
        } = action.selected

        if (
          shouldShowProTrialExpiredModal ||
          shouldShowBusinessTrialExpiredModal
        ) {
          dispatch(actions.showTrialCompleteModal())
        }
        break
      }

      case actionTypes.SHOW_TAG_FORM_MODAL:
        // eslint-disable-next-line no-case-declarations
        const { editMode, isFromSelector, tag } = action
        dispatch(openTagForm({ editMode, isFromSelector, tag }))
        break

      case actionTypes.HIDE_TAG_FORM_MODAL:
        dispatch(closeTagForm({}))
        break

      default:
        break
    }
  }
